/* Estrani - 'vaak samen gekocht' in de winkelwagen. Door Claude gebouwd, veilig te verwijderen.

   OPBOUW. Een liggende strip met grote foto's die je opzij schuift, in plaats van
   een stapel brede rijen. Reden: je verkoopt kleren met foto's, en drie brede
   rijen namen 522px hoogte in de la - op een telefoon bleef er dan te weinig
   over voor de artikelen die er al in zitten.

   Per kaart: de foto, een rond plusje rechtsonder, daaronder de kleurbolletjes,
   de titel en de prijs. De kleurbolletjes staan dus meteen in beeld. Tik je op
   het plusje, dan schuiven de maten open over de onderkant van de foto; tik je
   een maat aan, dan zit het in de winkelwagen. Heeft een product maar een
   variant, dan voegt het plusje meteen toe.

   De eerste leverbare kleur staat vooraf aangeduid. Klik je een bolletje aan,
   dan wisselt de foto mee en worden de maten opnieuw nagekeken; maten die in
   die kleur niet leverbaar zijn, komen doorstreept te staan.

   De kleuren komen uit dezelfde lijst als de bolletjes op de productkaarten
   (snippets/ai-kleurbollen.liquid). Verander je daar een tint, pas hem dan ook
   hier aan. */
(function () {
  'use strict';
  var CFG = null, PROD = {}, LIST = null, SEED = null, CACHE = {}, busy = false, timer = null;
  var lastCount = -1, haveData = false;

  var KLEUREN = {
    'zwart': '#1a1a1a', 'antraciet': '#3a3a3c', 'donkergrijs': '#4f4f52', 'grijs': '#8a8a8d',
    'lichtgrijs': '#c3c3c5', 'wit': '#ffffff', 'gebroken wit': '#f2ede4', 'creme': '#f0e6d2',
    'beige': '#d9c8ae', 'camel': '#b08a54', 'khaki': '#9b8b5e', 'olijfgroen': '#6b6f3a',
    'saliegroen': '#9aa98c', 'groen': '#3f7a4e', 'donkergroen': '#24472f', 'bosgroen': '#2c4a37',
    'bruin': '#7b4f33', 'chocoladebruin': '#4a2f21', 'mokka': '#6f5244', 'marineblauw': '#1f2d4d',
    'donkerblauw': '#1b2a44', 'koningsblauw': '#2b4fa8', 'blauw': '#3a5e9e', 'lichtblauw': '#a7c4dd',
    'hemelsblauw': '#8fb8d9', 'petrol': '#1f5560', 'rood': '#b4322c', 'bordeaux': '#6e1f2a',
    'wijnrood': '#5e1b26', 'oudroze': '#d7a8a0', 'abrikoos': '#e8b48b', 'geel': '#e3c04a'
  };

  function tint(naam) {
    var s = String(naam || '').toLowerCase().trim();
    if (s.slice(0, 2) === 'cr') s = 'creme';   /* Creme wordt met accent geschreven */
    return KLEUREN[s] || '#d8d2ca';
  }

  function cfg() {
    if (CFG) return CFG;
    var el = document.getElementById('ai-cart-upsell-data');
    if (!el) return null;
    try { CFG = JSON.parse(el.textContent); } catch (e) { return null; }
    return CFG;
  }

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* Zelfde schrijfwijze als de rest van het thema: EUR71,95 zonder spatie na het
     teken. Intl.NumberFormat zet daar een vaste spatie tussen, vandaar handwerk. */
  function money(cents) {
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    var n = (cents / 100).toFixed(2).split('.');
    var heel = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    if (cur === 'EUR') return '€' + heel + ',' + n[1];
    try {
      return new Intl.NumberFormat('nl-BE', { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) {
      return heel + ',' + n[1] + ' ' + cur;
    }
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function optIndex(p, re) {
    var o = p.options || [], i;
    for (i = 0; i < o.length; i++) {
      var n = typeof o[i] === 'string' ? o[i] : (o[i].name || '');
      if (re.test(n)) return i;
    }
    return -1;
  }

  /* Alle waarden van een optie, in de volgorde waarin de varianten staan. */
  function alleWaarden(p, idx) {
    var seen = {}, out = [];
    (p.variants || []).forEach(function (v) {
      var val = v.options[idx];
      if (val && !seen[val]) { seen[val] = 1; out.push(val); }
    });
    return out;
  }

  /* Waarden die in deze kleur ook echt leverbaar zijn. */
  function leverbaar(p, idx, filterIdx, filterVal) {
    var seen = {};
    (p.variants || []).forEach(function (v) {
      if (!v.available) return;
      if (filterIdx > -1 && v.options[filterIdx] !== filterVal) return;
      if (v.options[idx]) seen[v.options[idx]] = 1;
    });
    return seen;
  }

  function findVariant(p, ci, kleur, si, maat) {
    return (p.variants || []).filter(function (v) {
      if (!v.available) return false;
      if (ci > -1 && v.options[ci] !== kleur) return false;
      if (si > -1 && v.options[si] !== maat) return false;
      return true;
    })[0];
  }

  function thumb(url, w) {
    if (!url) return '';
    return url.indexOf('?') > -1 ? url + '&width=' + w : url + '?width=' + w;
  }

  /* De foto die bij een kleur hoort; valt terug op de hoofdfoto. */
  function fotoVoor(p, ci, kleur) {
    if (ci > -1) {
      var v = (p.variants || []).filter(function (x) { return x.options[ci] === kleur; })[0];
      var f = v && v.featured_image;
      if (f) return typeof f === 'string' ? f : (f.src || '');
    }
    return p.featured_image || (p.images && p.images[0]) || '';
  }

  function matenHTML(p, ci, si, kleur) {
    if (si < 0) return '';
    var alles = alleWaarden(p, si);
    var kan = leverbaar(p, si, ci, kleur);
    return '<div class="ai-ups__maten">' + alles.map(function (m) {
      var uit = !kan[m];
      return '<button type="button" class="ai-ups__maat" data-act="maat" data-val="' + esc(m) + '"' +
        (uit ? ' disabled' : '') + '>' + esc(m) + '</button>';
    }).join('') + '</div>';
  }

  function cardHTML(p) {
    var ci = optIndex(p, /kleur|colou?r/i);
    var si = optIndex(p, /maat|size/i);
    var kleuren = ci > -1 ? alleWaarden(p, ci) : [];
    /* De eerste kleur die echt leverbaar is, staat vooraf aangeduid. */
    var kanKleur = ci > -1 ? leverbaar(p, ci, -1, null) : {};
    var kleur = kleuren.filter(function (k) { return kanKleur[k]; })[0] || kleuren[0] || null;

    var bollen = kleuren.length > 1
      ? '<ul class="ai-ups__kleuren">' + kleuren.map(function (k) {
          return '<li><button type="button" class="ai-ups__kleur" data-act="kleur" data-val="' + esc(k) + '"' +
            ' style="--u-dot:' + tint(k) + '" aria-pressed="' + (k === kleur ? 'true' : 'false') + '">' +
            '<span class="visually-hidden">' + esc(k) + '</span></button></li>';
        }).join('') + '</ul>'
      /* Ook bij een product met een kleur zetten we de lege lijst neer. Zo
         staan de titels van alle kaarten in de strip op dezelfde hoogte. */
      : '<ul class="ai-ups__kleuren" aria-hidden="true"></ul>';

    var laag = si > -1
      ? '<div class="ai-ups__maatlaag" hidden>' + matenHTML(p, ci, si, kleur) + '</div>'
      : '';

    return '<li class="ai-ups__card" data-pid="' + p.id + '" data-ci="' + ci + '" data-si="' + si + '"' +
      ' data-kleur="' + esc(kleur || '') + '">' +
      '<div class="ai-ups__media">' +
      '<a class="ai-ups__fotolink" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' +
      '<img src="' + esc(thumb(fotoVoor(p, ci, kleur), 400)) + '" alt="" loading="lazy" width="150" height="206">' +
      '</a>' +
      laag +
      '<button type="button" class="ai-ups__plus" data-act="plus" aria-expanded="false"' +
      ' aria-label="' + esc(si > -1 ? CFG.choose_label : CFG.add_label) + '">' +
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 5v14M5 12h14"/></svg>' +
      '</button>' +
      '</div>' +
      bollen +
      '<a class="ai-ups__name" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
      '<span class="ai-ups__price">' + money(p.price) + '</span>' +
      '</li>';
  }

  /* Na een klik op een bolletje: foto en maten bijwerken. */
  function herteken(card) {
    var p = PROD[card.getAttribute('data-pid')];
    if (!p) return;
    var ci = parseInt(card.getAttribute('data-ci'), 10);
    var si = parseInt(card.getAttribute('data-si'), 10);
    var kleur = card.getAttribute('data-kleur') || null;

    var img = card.querySelector('.ai-ups__media img');
    if (img) {
      var nieuw = thumb(fotoVoor(p, ci, kleur), 400);
      if (nieuw && img.getAttribute('src') !== nieuw) img.setAttribute('src', nieuw);
    }
    card.querySelectorAll('.ai-ups__kleur').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-val') === kleur ? 'true' : 'false');
    });
    var oud = card.querySelector('.ai-ups__maten');
    if (oud && si > -1) {
      var houder = document.createElement('div');
      houder.innerHTML = matenHTML(p, ci, si, kleur);
      oud.replaceWith(houder.firstElementChild);
    }
  }

  function sluitLagen(behalve) {
    document.querySelectorAll('.ai-ups__card').forEach(function (c) {
      if (c === behalve) return;
      var l = c.querySelector('.ai-ups__maatlaag');
      var pl = c.querySelector('.ai-ups__plus');
      if (l) l.hidden = true;
      if (pl) pl.setAttribute('aria-expanded', 'false');
      c.classList.remove('is-open');
    });
  }

  function render() {
    var c = cfg();
    if (!c || !c.enable) return;
    busy = true;
    hosts().forEach(function (h) {
      var node = h.querySelector(':scope > .ai-ups');
      if (!LIST || !LIST.length) { if (node) node.remove(); return; }
      if (!node) {
        node = document.createElement('div');
        node.className = 'ai-ups';
        h.appendChild(node);
      }
      var html = '<div class="ai-ups__kop">' +
        '<p class="ai-ups__title">' + esc(c.title) + '</p>' +
        '<div class="ai-ups__pijlen">' +
        '<button type="button" class="ai-ups__pijl" data-act="vorig" aria-label="Vorige">' +
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg></button>' +
        '<button type="button" class="ai-ups__pijl" data-act="volgend" aria-label="Volgende">' +
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg></button>' +
        '</div></div>' +
        '<ul class="ai-ups__list">' + LIST.map(cardHTML).join('') + '</ul>';
      if (node.innerHTML !== html) node.innerHTML = html;
      pijlen(node);
    });
    busy = false;
  }

  /* De pijltjes verbergen zich als alles al past. */
  function pijlen(node) {
    var lijst = node.querySelector('.ai-ups__list');
    var vak = node.querySelector('.ai-ups__pijlen');
    if (!lijst || !vak) return;
    var past = lijst.scrollWidth <= lijst.clientWidth + 2;
    vak.hidden = past;
    if (past) return;
    var zet = function () {
      var v = vak.querySelector('[data-act="vorig"]');
      var n = vak.querySelector('[data-act="volgend"]');
      if (v) v.disabled = lijst.scrollLeft <= 2;
      if (n) n.disabled = lijst.scrollLeft + lijst.clientWidth >= lijst.scrollWidth - 2;
    };
    if (!lijst.dataset.aiPijl) {
      lijst.dataset.aiPijl = '1';
      lijst.addEventListener('scroll', zet, { passive: true });
    }
    zet();
  }

  function hosts() {
    var list = [];
    document.querySelectorAll('cart-drawer-component .cart-drawer__items').forEach(function (el) { list.push(el); });
    document.querySelectorAll('.cart-page__items').forEach(function (el) { list.push(el); });
    return list;
  }

  function fetchList(cart) {
    var c = cfg();
    if (!c || !c.enable || !cart.items || !cart.items.length) { LIST = null; SEED = null; lastCount = 0; haveData = true; render(); return; }
    lastCount = cart.item_count;
    var seed = cart.items[0].product_id;
    var have = {};
    cart.items.forEach(function (i) { have[i.product_id] = 1; });
    var key = 'p' + seed;
    if (!CACHE[key]) {
      var u = root() + 'recommendations/products.json?product_id=' + seed + '&limit=10&intent=' + (c.intent || 'related');
      CACHE[key] = fetch(u, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (j) { return j.products || []; })
        .catch(function () { return []; });
    }
    CACHE[key].then(function (all) {
      var picked = all.filter(function (p) { return p.available && !have[p.id]; }).slice(0, c.limit || 3);
      picked.forEach(function (p) { PROD[p.id] = p; });
      LIST = picked;
      SEED = seed;
      haveData = true;
      render();
    });
  }

  function refreshCart() {
    fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(fetchList)
      .catch(function () {});
  }

  /* Horizon hertekent de winkelwagen niet op fetchCartData(); dat haalt enkel JSON op.
     De la luistert op document naar 'shopify:cart:lines-update' en gebruikt
     event.promise -> detail.sections[sectionId]. Daarom vragen we de section-HTML
     mee op bij /cart/add.js en geven we die in exact die vorm door. */
  function sectionIds() {
    var out = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
      var id = el.getAttribute('data-section-id');
      if (id && out.indexOf(id) === -1) out.push(id);
    });
    return out;
  }

  function tellTheme(data) {
    var ev;
    try {
      ev = new CustomEvent('shopify:cart:lines-update', { bubbles: true });
    } catch (e) {
      return;
    }
    ev.action = 'add';
    ev.context = 'cart';
    ev.promise = Promise.resolve({
      detail: {
        sections: (data && data.sections) || undefined,
        items: (data && data.items) || undefined,
        source: 'ai-cart-upsell',
        didError: false
      }
    });
    document.dispatchEvent(ev);
  }

  function addVariant(card, id) {
    var btns = card.querySelectorAll('button');
    btns.forEach(function (b) { b.disabled = true; });
    var payload = { items: [{ id: id, quantity: 1 }] };
    var ids = sectionIds();
    if (ids.length) {
      payload.sections = ids.join(',');
      payload.sections_url = window.location.pathname;
    }
    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json(); })
      .then(function (data) {
        var laag = card.querySelector('.ai-ups__maatlaag');
        if (laag) { laag.hidden = true; }
        card.classList.remove('is-open');
        card.classList.add('is-gedaan');
        var media = card.querySelector('.ai-ups__media');
        if (media && !media.querySelector('.ai-ups__done')) {
          var klaar = document.createElement('p');
          klaar.className = 'ai-ups__done';
          klaar.textContent = CFG.added_label;
          media.appendChild(klaar);
        }
        tellTheme(data);
        setTimeout(refreshCart, 350);
      })
      .catch(function () { btns.forEach(function (b) { b.disabled = false; }); });
  }

  function onClick(e) {
    var t = e.target.closest ? e.target.closest('[data-act]') : null;
    if (!t) return;
    var act = t.getAttribute('data-act');

    if (act === 'vorig' || act === 'volgend') {
      var blok = t.closest('.ai-ups');
      var lijst = blok && blok.querySelector('.ai-ups__list');
      if (!lijst) return;
      e.preventDefault();
      var kaart = lijst.querySelector('.ai-ups__card');
      var stap = kaart ? kaart.getBoundingClientRect().width + 10 : 160;
      lijst.scrollBy({ left: act === 'volgend' ? stap : -stap, behavior: 'smooth' });
      return;
    }

    var card = t.closest('.ai-ups__card');
    if (!card) return;
    e.preventDefault();

    if (act === 'kleur') {
      card.setAttribute('data-kleur', t.getAttribute('data-val'));
      herteken(card);
      return;
    }

    if (act === 'plus') {
      var pp = PROD[card.getAttribute('data-pid')];
      var psi = parseInt(card.getAttribute('data-si'), 10);
      if (!pp) return;
      /* Geen maten? Dan is er niets te kiezen en gaat het meteen in de wagen. */
      if (psi < 0) {
        var pci = parseInt(card.getAttribute('data-ci'), 10);
        var pv = findVariant(pp, pci, card.getAttribute('data-kleur'), -1, null);
        if (pv) addVariant(card, pv.id);
        return;
      }
      var laag = card.querySelector('.ai-ups__maatlaag');
      if (!laag) return;
      var open = laag.hidden;
      sluitLagen(card);
      laag.hidden = !open;
      card.classList.toggle('is-open', open);
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }

    if (act === 'maat') {
      var pr = PROD[card.getAttribute('data-pid')];
      if (!pr) return;
      var cidx = parseInt(card.getAttribute('data-ci'), 10);
      var sidx = parseInt(card.getAttribute('data-si'), 10);
      var v = findVariant(pr, cidx, card.getAttribute('data-kleur'), sidx, t.getAttribute('data-val'));
      if (v) addVariant(card, v.id);
    }
  }

  function schedule() {
    if (busy) return;
    /* Het thema hertekent de regels in de la en gooit ons blok daarbij weg. Deze
       functie draait vanuit de MutationObserver, dus nog voor de browser tekent:
       meteen terugzetten, anders zie je het blok een paar tienden seconden
       wegflikkeren. De vertraagde controle hieronder ververst daarna de inhoud. */
    if (haveData && LIST && LIST.length && !document.querySelector('.ai-ups')) render();
    clearTimeout(timer);
    timer = setTimeout(function () {
      var b = document.querySelector('cart-drawer-component .theme-drawer__badge');
      var n = b ? parseInt((b.textContent || '').replace(/\D/g, ''), 10) : NaN;
      if (!isNaN(n) && n !== lastCount) { refreshCart(); return; }
      if (haveData && LIST && LIST.length && !document.querySelector('.ai-ups')) render();
    }, 150);
  }

  function boot() {
    if (!cfg() || !CFG.enable) return;
    refreshCart();
    document.addEventListener('click', onClick);
    ['shopify:cart:lines-update', 'cart:update', 'cart:updated'].forEach(function (n) {
      document.addEventListener(n, refreshCart);
      document.body.addEventListener(n, refreshCart);
    });
    var obs = new MutationObserver(schedule);
    document.querySelectorAll('cart-drawer-component, .cart-page__items').forEach(function (el) {
      obs.observe(el, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
